module.exports = __webpack_public_path__ + "static/presidents-1389884ae1f6cafe14c57545250d5e3b.webp";